import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../common/api"; // فایل api.js

// Async thunk برای دریافت اطلاعات بورس
export const fetchBourseData = createAsyncThunk("bourse/fetchBourseData", async () => {
  try {
    const response = await api.get("/Home/bourse"); // ارسال درخواست به API
    return response.data.data; // داده‌های مورد نظر در فیلد `data` قرار دارند
  } catch (error) {
    // در صورت بروز خطا می‌توانید خطای دقیق‌تر را اینجا مدیریت کنید
    console.error("API Error:", error);
    throw error; // پرتاب خطا برای مدیریت در `rejected`
  }
});

const bourseSlice = createSlice({
  name: "bourse",
  initialState: {
    bourse: null,
    status: "idle", // یا "loading", "failed"
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBourseData.pending, (state) => {
        state.status = "loading"; // هنگام شروع درخواست، وضعیت را به "در حال بارگذاری" تغییر می‌دهیم
      })
      .addCase(fetchBourseData.fulfilled, (state, action) => {
        state.status = "succeeded"; // موفقیت آمیز بودن درخواست
        state.bourse = action.payload; // ذخیره داده‌ها در استیت
      })
      .addCase(fetchBourseData.rejected, (state, action) => {
        state.status = "failed"; // درخواست شکست خورده
        state.error = action.error.message; // ذخیره پیغام خطا
      });
  },
});

export default bourseSlice.reducer;
